import { type FC } from 'react';

import { Button, Flex, Tooltip } from '@highereducation/hen-ui';

type Props = {
  position?: 'below' | 'above';
  spanText?: string;
  disclosureTitle?: string;
  disclosureContent?: string;
};

export const DISCLOSURE_COPY =
  'This site is a free online resource that strives to offer helpful content and comparison features to our visitors. We accept advertising compensation from companies that appear on the site, which impacts the location and order in which brands (and/or their products) are presented, and also impacts the score that is assigned to it. Company listings on this page DO NOT imply endorsement. We do not feature all providers on the market.';

export const SponsoredResultsPopover: FC<Props> = ({
  position = 'below',
  spanText = 'Sponsored',
  disclosureTitle,
  disclosureContent,
}) => {
  const triggerText = disclosureTitle?.trim() || spanText;

  return (
    <Flex direction='row' align='center' className='shrink-0'>
      <Tooltip
        content={getDisclosureCopy(disclosureContent)}
        side={position === 'above' ? 'top' : 'bottom'}
      >
        <Button
          type='button'
          variant='textOnlyNeutral'
          size='flush'
          iconAfter='info'
        >
          {triggerText}
        </Button>
      </Tooltip>
    </Flex>
  );
};

function getDisclosureCopy(disclosureContent?: string): string {
  const content = disclosureContent?.trim();
  return content || DISCLOSURE_COPY;
}

export default SponsoredResultsPopover;
